import React from 'react';
import Base from '../../containers/base';
import Event from 'react-eventproxy';
import {callViewName,connectEventName} from '../../utils/websocket'
import { message, Icon } from 'antd';

let loadingHide = null;

export default class Index extends Base {
  constructor(props) {
    super(props);
    this.state = {
        list:[],
        isConnect:false
    };
  }
  componentDidMount(){
      const self = this;
      console.warn('123')
    Event.on(callViewName,({data,option})=>{
        let {list} = self.state;
        let arrs = [...list,...data];
        if(arrs.length>6){
            arrs.splice(0,arrs.length - 6);
        }
        self.setState({
            list:arrs
        })
    })
    
    Event.on(connectEventName,({msg})=>{

        if(msg == '连接成功'){
            if(loadingHide){
                loadingHide();
            }
            self.setState({
                isConnect:true
            })
        }else{
            loadingHide = message.loading('重新连接 ...',0)
            self.setState({
                isConnect:false
            },()=>{
                self.WS.init();
            })
        }
    });
  }
  render() {
    const headerHeight = 163/2;
    const { list,isConnect } = this.state;
    return (
      <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden',backgroundColor: 'black',}}>
          <header>
              <img  style={{width:'100%',height:headerHeight}} src='https://soreal-icon.oss-cn-beijing.aliyuncs.com/queue/icon_top_bg.png' />
              <div style={{position:'absolute',width:'100%',height:headerHeight,top:0,left:0,display:'flex',alignItems:'center'}}>
                    <div style={{flex:1,height:headerHeight,paddingTop:5,paddingLeft:20}}>
                        {/* <span style={{fontSize:30,color:'white'}}>SOREAL</span> */}
                        <img style={{height:20,marginTop:12}} src='https://soreal-icon.oss-cn-beijing.aliyuncs.com/queue/iocn_logo.png' />
                    </div>
                    <div style={{flex:1,height:headerHeight,paddingTop:5,paddingLeft:20,display:'flex',alignItems:'center',justifyContent: 'center',flexDirection:'column'}}>
                        <span style={{fontSize:30,color:'white'}}>虚拟空间等候区</span>
                        <span style={{color:'rgb(111,133,168)'}}>Virtual space waiting area</span>
                    </div>
                    <div style={{flex:1,height:headerHeight,paddingTop:5,paddingLeft:20,justifyContent:'flex-end',alignItems: 'center',display:'flex',marginBottom: 30}} />
              </div>
          </header>
          <div style={{width:'100%',flex:1,display:'flex',display:'flex',flexDirection:'column',alignItems: 'center',paddingTop:20,scroll:'auto'}}>
                {
                    list && list.map((item,index)=>{
                        return (
                            <CallItem key={Math.random()+''} queueNum = {item} />
                        )
                    })
                }
          </div>
          {/* <div onClick={this.onAddCallPress} style={{position:'absolute',left:0,top:200,color:'white'}}>
              <span>添加+++++++++++++++++++</span>
          </div> */}
          
      </div>
    );
  }
  onAddCallPress = ()=>{
      let { list } = this.state;
      let arrs = [...list,{queueNum:Math.floor(Math.random() * (100 - 1)) + 1,remove:false}];
      if(arrs.length > 8){
        //   //移除第一个
        //   arrs[0].remove =true;
        //   //渐变最后一个
        //   arrs[arrs.length-1].remove =false;
        //   arrs.splice(0,1)
      }
      
      this.setState({list:arrs},()=>{
          
      });
  }
}

class CallItem extends React.Component {
    render(){
        const {queueNum} = this.props;
        const css = {position:'relative',color:'white',width:'100%',height:70};
        return (
            <div style={{...css}}>
               <img style={{position:'absolute',top:0,left:'10%',width:'80vw'}} src='https://soreal-icon.oss-cn-beijing.aliyuncs.com/queue/icon_item_bg.png' />
                <div style={{display:'flex',flexDirection:'row',justifyContent: 'center',alignItems:'center',paddingTop:3,paddingBottom:10}}>
                    <div style={{fontSize:18,backgroundColor:'rgb(69,119,213)',paddingLeft:30,paddingRight:30,paddingTop:5,paddingBottom:5,borderRadius:10}}><span>{queueNum}号</span></div>
                    <div style={{display:'flex',flexDirection:'column',marginLeft:30}}>
                        <span style={{fontSize:20}}>{`请${queueNum}号旅行者到服务台，您的虚拟空间探险之旅即将开启`}</span>
                        <span style={{color:'rgb(111,133,168)'}}>{`Please visit the service desk on the ${queueNum}th，your adventure will open soon.`}</span>
                    </div>
                </div>
            </div>
        );
    }
}

